import { restApiClient } from '@/datasources';

export const CHANGE_CART_PATIENT_ROUTE = '/online/cart/change-patient';

export interface CartItemPatientPair {
  cartItemId: string;
  patientId: string;
}

export async function changeCartPatient(cartItemsAndPatients: CartItemPatientPair[]): Promise<void> {
  await restApiClient.put(CHANGE_CART_PATIENT_ROUTE, { cartItemsAndPatients });
}
